import React, { ReactElement, useEffect, useState } from 'react'
import { destroyForm } from 'core/actions/Common'
import { FormMode } from 'shared/interfaces'
import { createApiToken } from '../ApiTokens.actions'
import ApiTokenForm from '../api-token-form'
import { ApiTokenFormValues } from '../api-token-form/ApiTokenForm.types'
import { CreateApiTokenProps, CreateApiTokenStateProps } from './CreateApiToken.types'
import { ApiTokenFormAdapter, ApiTokenFormFields } from '../api-token-form/ApiTokenForm.constants'
import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import { change } from 'redux-form'
import { withPermissionsHOC } from 'core/hoc/permissionsHoc'
import moment from 'moment'
import { Translate } from 'react-localize-redux'
import { RouterConfig } from '../../../core/utils/constants'
import history from '../../../core/history/history'
import styles from '../ApiTokens.module.scss'

const CreateApiToken = (props: CreateApiTokenProps): ReactElement => {
  const { apiTokens, change } = props
  const [isLoading, setLoading] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)

  useEffect(() => {
    if (props.apiTokens && props.apiTokens.length < 20) {
      change(ApiTokenFormAdapter.name, ApiTokenFormFields.apiTokens, props.apiTokens)
    }
  }, [apiTokens, change])

  const onCancel = () => {
    if(document.referrer === '') {
      window.close()
    }
    history.push(RouterConfig.administrators.details(props.userId))
  }

  const onSubmit = async (values: ApiTokenFormValues): Promise<void> => {
    setLoading(true)

    const payload = {
      name: values.name,
      end_date: values.end_date ? moment.utc(values.end_date).format() : null,
      enabled: true
    }

    await props.createApiToken(payload)
    setCurrentStep(currentStep + 1)
    setLoading(false)
  }

  return (
    <div className={styles.apiTokenContainer}>
      <h1>{currentStep === 1 ? <Translate id='apiTokens.form.createToken'/> : <Translate id='apiTokens.congratulations'/>}</h1>
      <ApiTokenForm
        mode={FormMode.create}
        location={props.location}
        onSubmit={onSubmit}
        hash={props.location.hash}
        link={props.match.url}
        isLoading={isLoading}
        destroyForm={props.destroyForm}
        apiToken={props.apiToken}
        userId={props.userId}
        onCancel={onCancel}
      />
    </div>
  )
}

export default connect(
  (state: IAppState): CreateApiTokenStateProps => ({
    apiToken: state.apiTokens.apiToken,
    apiTokens: state.apiTokens.items,
    userId: state.profile.data !== undefined ?  state.profile.data.id : ''
  }),
  { 
    createApiToken,
    destroyForm,
    change
  }
)(withPermissionsHOC(CreateApiToken, []))
